import React, { memo, useEffect, useMemo, useState } from 'react';

const preloadImage = (src) => {
  if (!src) {
    return;
  }

  const image = new Image();
  image.src = src;
};

const HeroBackgroundSlideshow = ({
  images = [],
  intervalMs = 4000,
  className = 'hero-bg',
  layerClassName = 'hero-bg-layer',
  overlayClassName = 'hero-bg-overlay',
}) => {
  const normalizedImages = useMemo(
    () => images.filter(Boolean),
    [images]
  );
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!normalizedImages.length) {
      return undefined;
    }

    setCurrentIndex((prev) => (prev >= normalizedImages.length ? 0 : prev));
    preloadImage(normalizedImages[0]);
    preloadImage(normalizedImages[1]);

    return undefined;
  }, [normalizedImages]);

  useEffect(() => {
    if (normalizedImages.length < 2) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % normalizedImages.length);
    }, intervalMs);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [intervalMs, normalizedImages.length]);

  useEffect(() => {
    if (!normalizedImages.length) {
      return;
    }

    preloadImage(normalizedImages[currentIndex]);
    preloadImage(normalizedImages[(currentIndex + 1) % normalizedImages.length]);
  }, [currentIndex, normalizedImages]);

  if (!normalizedImages.length) {
    return null;
  }

  const previousIndex =
    normalizedImages.length > 1
      ? (currentIndex - 1 + normalizedImages.length) % normalizedImages.length
      : currentIndex;

  return (
    <div className={className} aria-hidden="true">
      {normalizedImages.length > 1 && (
        <div
          className={layerClassName}
          style={{ backgroundImage: `url(${normalizedImages[previousIndex]})` }}
        />
      )}
      <div
        className={`${layerClassName} is-active`}
        style={{ backgroundImage: `url(${normalizedImages[currentIndex]})` }}
      />
      <div className={overlayClassName} />
    </div>
  );
};

export default memo(HeroBackgroundSlideshow);
